import React from 'react';
import { Award, CheckCircle, Shield } from 'lucide-react';

const About = ({ translations }) => {
  const features = [
    {
      icon: <Award size={24} />,
      text: translations.about.experience
    },
    {
      icon: <CheckCircle size={24} />,
      text: translations.about.quality
    },
    {
      icon: <Shield size={24} />,
      text: translations.about.certified
    }
  ];

  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="about-content">
          <div className="about-image">
            <img 
              src="https://images.unsplash.com/photo-1562564055-71e051d33c19?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMGRvY3VtZW50c3xlbnwwfHx8fDE3Njk4ODMzNTl8MA&ixlib=rb-4.1.0&q=85"
              alt="Professional Services"
              className="about-img"
            />
          </div>
          <div className="about-text">
            <h2 className="section-title">{translations.about.title}</h2>
            <p className="about-description">
              {translations.about.content}
            </p>
            <div className="about-features">
              {features.map((feature, index) => (
                <div key={index} className="about-feature">
                  <div className="feature-icon">
                    {feature.icon}
                  </div>
                  <span className="feature-text">{feature.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
